import CopiableInput from "common/components/CopiableInput";
import { Button } from "common/components/ui/Button";
import {
  DialogBody,
  DialogFooter,
  DialogHeader,
} from "common/components/ui/Dialog";
import {
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
} from "common/components/ui/Drawer";
import FormField from "common/components/ui/FormField";
import useCopyText from "common/hooks/useCopyText";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";
import type { Member } from "common/types";

import useAgencySettings from "../datahooks/useAgencySettings";
import useClientLoginUrl from "../datahooks/useClientLoginUrl";

interface LoginLinkProps {
  member: Member;
  onBack: () => void;
}

export default function LoginLink({ member, onBack }: LoginLinkProps) {
  const isDesktop = useTwBreakpoint("lg");
  const { agencySettings } = useAgencySettings();

  const { email, first_name, last_name } = member;

  const { loginUrl, isGeneratingLoginUrl, loginUrlError } = useClientLoginUrl(
    email,
    agencySettings.slug,
  );
  const { isCopied, copyText } = useCopyText(loginUrl);
  const Footer = isDesktop ? DialogFooter : DrawerFooter;
  const Body = isDesktop ? DialogBody : DrawerBody;
  const Header = isDesktop ? DialogHeader : DrawerHeader;

  return (
    <>
      <Header
        title="White label login link"
        subtitle={
          <>
            White label login links expire after 7 days. This link is valid for:{" "}
            {first_name} {last_name} -{" "}
            <span className="text-sm-bold text-black-950">{email}</span>
          </>
        }
      />

      <Body>
        <FormField label="" htmlFor="login-url" error={loginUrlError?.message}>
          <CopiableInput
            id="login-url"
            value={isGeneratingLoginUrl ? "Generating link..." : loginUrl}
            isLoading={isGeneratingLoginUrl}
          />
        </FormField>
      </Body>

      <Footer className="justify-end">
        <Button variant="secondary-black" onClick={onBack}>
          Cancel
        </Button>
        <Button
          onClick={copyText}
          isLoading={isGeneratingLoginUrl}
          disabled={!loginUrl}
        >
          {isCopied ? "Copied!" : "Copy link"}
        </Button>
      </Footer>
    </>
  );
}
